import PropTypes from 'prop-types';

const tooltipPayloadType = PropTypes.shape({
  color: PropTypes.string,
  dataKey: PropTypes.string,
  fill: PropTypes.string,
  fillOpacity: PropTypes.number,
  formatter: PropTypes.func,
  name: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  unit: PropTypes.string,
  value: PropTypes.number,
});

export default tooltipPayloadType;
